// extracted by mini-css-extract-plugin
export default {"back":"ActivityPage_back__m6MBU","back-icon":"ActivityPage_back-icon__umgmw"};